import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { H3 } from 'foundations-components/transitional/components/H3';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { mapCategoryToTranslationKey } from './utils/categoryMapping';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function Header({
  portalId,
  category
}) {
  if (!portalId || category === null) {
    return null;
  }
  const translationKey = mapCategoryToTranslationKey(category);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(H3, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `app.headers.${translationKey}.heading`
      }), category === 'scheduled-for-release' && /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.headers.scheduledForRelease.tooltip"
        }),
        tooltipPlacement: "right"
      })]
    }), /*#__PURE__*/_jsx("p", {
      children: category === 'recommended' ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "app.headers.recommended.text_jsx",
        options: {
          href: `/settings/${portalId}/audits`
        },
        elements: {
          Link
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `app.headers.${translationKey}.text`
      })
    })]
  });
}
export default Header;